<template>
  <b-modal
    :id="modalName"
    :size="modalSize"
    hide-footer
    hide-header
    centered
    title="Emitir"
  >
    <div>
      <div class="headerModal">
        <div
          style="
            display: flex;
            align-items: center;
            gap: 1rem;
            position: relative;
          "
        >
          <div class="contentIconHeader" style="width: 40px; height: 40px">
            <component
              v-if="options.header.icon"
              :is="options.header.icon"
              :style="options.header.styleIcon"
            />
          </div>

          <h6 class="titleModal">{{ options.header.title }}</h6>

          <div class="contentCloseIcon" @click="$bvModal.hide(modalName)">
            <b-icon-x-lg style="width: 12px; height: 12px; color: white" />
          </div>
        </div>

        <p
          style="
            margin: 0;
            color: #ffffffde;
            font-size: 0.8rem;
            font-weight: 500;
            margin-left: 3.5rem;
          "
        >
          {{ options.header.subtitle }}
        </p>
      </div>

      <div class="btnModal">
        <div
          :style="`
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            justify-content: space-around;
            flex-direction: ${flexDirection || 'column'};
            flex-wrap: wrap;
          `"
        >
          <button
            :class="`btnActionModal ${opt.hoverColor}`"
            @click="opt?.click && opt.click()"
            v-show="opt.show !== false"
            v-for="(opt, idx) in options.buttons"
            :key="idx"
          >
            <div
              style="
                display: flex;
                align-items: center;
                gap: 1rem;
                padding: 1rem 1.2rem;
              "
            >
              <div class="contentIconHeader" :style="opt.backIconColor">
                <component
                  v-if="opt.icon"
                  :is="opt.icon"
                  :style="opt.styleIcon"
                />
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <p style="margin: 0; font-size: 0.875rem; white-space: nowrap">
                  {{ opt.title || "Titulo não informado" }}
                </p>
                <p
                  style="
                    margin: 0;
                    font-size: 0.7rem;
                    color: oklch(0.4 0.03 257.39);
                    white-space: nowrap;
                  "
                >
                  {{ opt.subtitle || "Subtitulo não informado" }}
                </p>
              </div>
            </div>
          </button>
        </div>

        <hr style="width: 100%; background-color: #80808000; margin: 0" />

        <div
          :style="{
            width: '100%',
            display: 'flex',
            justifyContent: showGenerateOrder ? 'space-between' : 'center',
            alignItems: 'center',
            gap: '1rem',
          }"
        >
          <button
            v-if="options?.footer?.button?.click && showGenerateOrder"
            @click="
              options?.footer?.button?.click && options?.footer?.button?.click()
            "
            class="btnActionModal"
            style="
              width: auto;
              border-radius: 5px;
              padding: 0.5rem;
              box-shadow: rgb(103 167 226) 0px 0px 1px 1px;
            "
          >
            <div style="display: flex; align-items: center; gap: 0.8rem">
              <component
                v-if="options?.footer?.button?.icon"
                :is="options?.footer?.button?.icon"
                style="color: rgb(69 135 197)"
              />

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <p style="margin: 0; font-size: 0.75rem; color: rgb(16 68 117)">
                  {{ options?.footer?.button?.title }}
                </p>
              </div>
            </div>
          </button>

          <button
            v-if="!spinLoading"
            @click="startNewSale"
            class="btnActionModal"
            style="
              width: auto;
              border-radius: 5px;
              padding: 0.5rem;
              min-width: 200px;
              text-align: center;
              max-width: 200px;
            "
          >
            <div style="display: flex; justify-content: center; gap: 0.8rem">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <p style="margin: 0; font-size: 0.75rem; color: black">
                  Não, Obrigado!
                </p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>

    <Loading v-if="spinLoading" class="spin" />
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    modalName: {
      type: String,
      default: "modal-default",
    },
    modalSize: {
      type: String,
      default: "md",
    },
    showGenerateOrder: {
      type: Boolean,
      default: false,
    },
    flexDirection: {
      type: String,
      default: "column",
    },
    options: {
      type: Object,
      default: () => ({
        header: {
          icon: null,
          backIconColor: null,
          title: null,
          subtitle: null,
        },
        buttons: [
          {
            icon: null,
            backIconColor: null,
            title: null,
            subtitle: null,
            borderColor: null,
          },
        ],
        footer: {
          button: {
            icon: "b-icon-file-earmark-text",
            title: "Informe o Titulo",
            click: null,
          },
        },
      }),
    },
  },
  data() {
    return {
      spinLoading: false,
      isOtherPrints: false,
      typeIntegration: "stone",
      machineTypes: [
        { text: "Stone", value: "stone" },
        { text: "Vero", value: "vero" },
      ],
    };
  },
  methods: {
    startNewSale() {
      this.$emit("clearAll");

      this.$bvModal.hide(this.modalName);
    },
  },
  computed: {
    ...mapState({}),
  },
};
</script>

<style scoped>
.titleModal {
  font-size: 1.2rem;
  color: white;
  font-weight: 500;
  margin: 0;
}

.rejectModal {
  cursor: pointer;
  color: black;
  display: flex;
  justify-content: center;
  font-size: 11px;
  font-style: oblique;
  text-decoration: underline;
}

.spin {
  width: 480px;
  height: 100%;
  top: 0;
}

/* MODAL STYLE */

::v-deep(.modal-body) {
  padding: 0;
}

::v-deep(.modal-content) {
  border-radius: 0.625rem;
}

.headerModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.2rem;
  background-color: #006458;
  border-radius: 0.5rem 0.5rem 0 0;
}

.contentCloseIcon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 50%;
  position: absolute;
  right: -10px;
  top: -10px;
  cursor: pointer;
  transition: ease-in all 0.1s;
}

.contentCloseIcon:hover {
  background-color: rgba(255, 255, 255, 0.376);
  transition: ease-in all 0.1s;
}

.btnModal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  justify-content: space-around;
  padding: 1rem 1.2rem;
}

.btnActionModal {
  width: 100%;
  flex: 1;
  outline: none;
  border: none;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(128, 128, 128, 0.248);
  background-color: transparent;
  transition: ease-in all 0.1s;
}

.btnActionModal:hover {
  transition: ease-in all 0.1s;
  background-color: rgba(132, 157, 140, 0.096);
}

.colorSuccess {
  box-shadow: 0 0 2px 1px rgb(74 153 100);
  transition: ease-in all 0.1s;
}

.colorSuccess:hover {
  transition: ease-in all 0.1s;
  background-color: rgba(74, 153, 100, 0.096);
}

.colorInfo {
  box-shadow: 0 0 2px 1px rgb(74, 131, 153);
  transition: ease-in all 0.1s;
}

.colorInfo:hover {
  transition: ease-in all 0.1s;
  background-color: rgb(74, 131, 153, 0.096);
}

.contentIconHeader {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 17%);
  border-radius: 8px;
}
</style>
